import * as React from 'react';
import * as ProgressPrimitive from '@radix-ui/react-progress';

import { cn } from '@/lib/utils';

const Progress = React.forwardRef<
	React.ElementRef<typeof ProgressPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
		classNameRoot?: string;
		classNameIndicator?: string;
	}
>(({ classNameRoot, classNameIndicator, value, children, ...props }, ref) => (
	<div className="relative w-full ">
		<ProgressPrimitive.Root
			ref={ref}
			className={cn(
				'h-2 w-full overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800',
				classNameRoot
			)}
			{...props}
		>
			<ProgressPrimitive.Indicator
				className={cn(
					'h-full flex-1 bg-slate-900 transition-all dark:bg-slate-50',
					classNameIndicator
				)}
				style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
			/>
		</ProgressPrimitive.Root>
		{children}
	</div>
));

Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
